import { StateStorage } from 'zustand/middleware'
import { createStore } from '../../state'

export interface MigrateV2Store {
  hasMigrated: boolean
  setHasMigrated: (hasMigrated: boolean) => void
}

export const createMigrateToV2Store = (storage: StateStorage) =>
  createStore<MigrateV2Store>(
    storage,
    (set) => ({
      hasMigrated: false,
      setHasMigrated: (hasMigrated: boolean) => {
        set({ hasMigrated })
      },
    }),
    {
      persist: {
        name: 'migrateV2',
        version: 0,
      },
    }
  )
